<footer class="footer bg-light mt-auto">
  <div class="container-fluid">
    <div class="row footer-row text-center text-md-start">
      <div class="col-4 text-muted align-self-center text-cc mb-2 mb-md-0">
        © smart.box {{ year }}. All Rights Reserved.
      </div>
    <div class="col-4 content-footer-logo align-self-center text-center mb-2 mb-md-0">
      <img
      src="assets/images/logo-smart-box.png"
      class="img-fluid footer-logo"
      alt="Smart Box"
      width="120"
      />
    </div>
    <div class="col-4 text-muted justify-content-end align-self-center text-center text-md-end" style="cursor: pointer;" (click)="reload()" (touchend)="reload()">
      Version: {{ data.VERSION }}
    </div>
  </div>
</div>
</footer>